module.exports = __webpack_public_path__ + "media/images/edit-icon-24px-66350ccb4fdae5f3cf0c071976f18398.svg";